/* eslint-disable */
import { createI18n } from 'vue-i18n'  // Vue 3 中用 createI18n 函数
import zh from './zh'
import en from './en'

// 创建 i18n 实例（Vue 3 语法）
const i18n = createI18n({
    legacy: false,  // 使用 Composition API，必须设置为 false
    locale: localStorage.getItem('appLang') || 'en',  // 默认语言
    fallbackLocale: 'en',
    messages: { zh, en }
})

export default i18n
